module.exports = __webpack_public_path__ + "media/images/proof_links/colored/quora-b2f9ce8bbddedb56ce182abe70c2640f.svg";